class PubSub {
  constructor() {
        this.subscribers = {
        'hubsUpdate': [],
        'urlUpdate': [] };
    }
    publish(eventName, data) {
        if (!this.subscribers[eventName]) return;
            this.subscribers[eventName].forEach((subscriberCallback) => {
                subscriberCallback(data !== undefined ? data : {});
            });
    }

    subscribe(eventName, callback) {
        if (!this.subscribers[eventName]) {
           this.subscribers[eventName] = [];
        }
        if (window.dobriInnerTest) {
            window.dobriInnerTest.push(callback);
        } else {
            window.dobriInnerTest = [];
            window.dobriInnerTest.push(callback);
        }
        this.subscribers[eventName].push(callback);

        return {
            unsubscribe() {
                this.subscribers[eventName].splice(index, 1);
            }
        };
    }
}

export default PubSub;

